import { useState, useEffect } from 'react';

interface ScreenDimensions {
  width: number;
  height: number;
  isMobile: boolean;
  isSmallMobile: boolean;
}

export const useScreenDimensions = (): ScreenDimensions => {
  const [dimensions, setDimensions] = useState<ScreenDimensions>(() => {
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const isMobile = viewportWidth <= 768;
    const isSmallMobile = viewportWidth <= 375;

    // Calculate actual Mac screen dimensions based on viewport
    let width: number;
    let height: number;

    if (isMobile) {
      // On mobile, screen uses calc(100vw - 20px) and calc(100vh - 20px)
      width = Math.min(768, viewportWidth - 20);
      height = Math.min(576, viewportHeight - 20);
    } else {
      // Desktop: fixed 768x576 with max constraints
      width = Math.min(768, viewportWidth - 80);
      height = Math.min(576, viewportHeight - 80);
    }

    return { width, height, isMobile, isSmallMobile };
  });

  useEffect(() => {
    const handleResize = () => {
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const isMobile = viewportWidth <= 768;
      const isSmallMobile = viewportWidth <= 375;

      let width: number;
      let height: number;

      if (isMobile) {
        width = Math.min(768, viewportWidth - 20);
        height = Math.min(576, viewportHeight - 20);
      } else {
        width = Math.min(768, viewportWidth - 80);
        height = Math.min(576, viewportHeight - 80);
      }

      setDimensions({ width, height, isMobile, isSmallMobile });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return dimensions;
};
